"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoteDelegation__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "ArraysOfDifferentSize",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "delegator",
                type: "address",
            },
        ],
        name: "DeleteDelegations",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "delegator",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "delegatee",
                        type: "address",
                    },
                    {
                        internalType: "string",
                        name: "command",
                        type: "string",
                    },
                    {
                        internalType: "uint256",
                        name: "maxValue",
                        type: "uint256",
                    },
                ],
                indexed: false,
                internalType: "struct VoteDelegation.Delegation[]",
                name: "delegationGrants",
                type: "tuple[]",
            },
        ],
        name: "GrantDelegations",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "delegationsMap",
        outputs: [
            {
                internalType: "address",
                name: "delegatee",
                type: "address",
            },
            {
                internalType: "string",
                name: "command",
                type: "string",
            },
            {
                internalType: "uint256",
                name: "maxValue",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "delegator",
                type: "address",
            },
        ],
        name: "getDelegations",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "delegatee",
                        type: "address",
                    },
                    {
                        internalType: "string",
                        name: "command",
                        type: "string",
                    },
                    {
                        internalType: "uint256",
                        name: "maxValue",
                        type: "uint256",
                    },
                ],
                internalType: "struct VoteDelegation.Delegation[]",
                name: "delegations",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "addresses",
                type: "address[]",
            },
            {
                internalType: "string[]",
                name: "commands",
                type: "string[]",
            },
            {
                internalType: "uint256[]",
                name: "maxValues",
                type: "uint256[]",
            },
        ],
        name: "grantDelegates",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "removeDelegates",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b50600054610100900460ff16158080156100315750600054600160ff909116105b8061005c575061004a3061013260201b6106281760201c565b15801561005c575060005460ff166001145b6100c35760405162461bcd60e51b815260206004820152602e60248201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160448201526d191e481a5b9a5d1a585b1a5e995960921b606482015260840160405180910390fd5b6000805460ff1916600117905580156100e6576000805461ff0019166101001790555b801561012c576000805461ff0019169055604051600181527f7f26b83ff96e1f2b6a682f133852f6798a09c465da95921460cefb38474024989060200160405180910390a15b50610141565b6001600160a01b03163b151590565b610c48806101506000396000f3fe608060405234801561001057600080fd5b50600436106100575760003560e01c8063270556421461005c57806331cc13ba146100715780638129fc1c1461009a578063affb7de9146100a2578063ff658a1f146100c4575b600080fd5b61006f61006a366004610723565b6100cc565b005b61008461007f3660046107d9565b6102bc565b6040516100919190610841565b60405180910390f35b61006f6103e3565b6100b56100b03660046108cd565b6104f0565b604051610091939291906108f7565b61006f6105c6565b84831415806100db5750848114155b156100f9576040516320e110c560e21b815260040160405180910390fd5b33600090815260016020526040902054156101265733600090815260016020526040812061012691610637565b60005b8581101561026b573360009081526001602052604090819020815160608101909252908089898581811061015f5761015f61092b565b905060200201602081019061017491906107d9565b6001600160a01b031681526020018787858181106101945761019461092b565b90506020028101906101a69190610941565b8080601f0160208091040260200160405190810160405280939291908181526020018383808284376000920191909152505050908252506020018585858181106101f2576101f261092b565b60209081029290920135909252835460018082018655600095865294829020845160039092020180546001600160a01b0319166001600160a01b039092169190911781559083015192939092908301915061024d9082610a27565b506040820151816002015550508061026490610ae7565b9050610129565b50336000818152600160205260409081902090517f288da8bae574fa4436cbe1a200b024dfde6d3868b8b2ed011cb9d1d4301457d7926102ac929091610b0e565b60405180910390a1505050505050565b6001600160a01b0381166000908152600160209081526040808320805482518185028101850190935280835260609492939192909184015b828210156103d857600084815260209081902060408051606081019091526003850290910180546001600160a01b03168252600181018054929391929184019161033d9061099e565b80601f01602080910402602001604051908101604052809291908181526020018280546103699061099e565b80156103b65780601f1061038b576101008083540402835291602001916103b6565b820191906000526020600020905b81548152906001019060200180831161039957829003601f168201915b50505050508152602001600282015481525050815260200190600101906102f4565b505050509050919050565b600054610100900460ff16158080156104035750600054600160ff909116105b8061041d5750303b15801561041d575060005460ff166001145b6104845760405162461bcd60e51b815260206004820152602e60248201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160448201526d191e481a5b9a5d1a585b1a5e995960921b606482015260840160405180910390fd5b6000805460ff1916600117905580156104a7576000805461ff0019166101001790555b80156104ed576000805461ff0019169055604051600181527f7f26b83ff96e1f2b6a682f133852f6798a09c465da95921460cefb38474024989060200160405180910390a15b50565b6001602052816000526040600020818154811061050c57600080fd5b6000918252602090912060039091020180546001820180546001600160a01b03909216945091925061053d9061099e565b80601f01602080910402602001604051908101604052809291908181526020018280546105699061099e565b80156105b65780601f1061058b576101008083540402835291602001916105b6565b820191906000526020600020905b81548152906001019060200180831161059957829003601f168201915b5050505050908060020154905083565b33600090815260016020526040902054156105f3573360009081526001602052604081206105f391610637565b6040513381527f71845356acf8cbd993db5c437a7ee381c5c10c1e81ad6363dc89e77c8b28b8689060200160405180910390a1565b6001600160a01b03163b151590565b50805460008255600302906000526020600020908101906104ed91905b808211156106895780546001600160a01b03191681556000610679600183018261068d565b5060006002820155600301610654565b5090565b5080546106999061099e565b6000825580601f106106a9575050565b601f0160209004906000526020600020908101906104ed91905b8082111561068957600081556001016106c3565b60008083601f8401126106e957600080fd5b50813567ffffffffffffffff81111561070157600080fd5b6020830191508360208260051b850101111561071c57600080fd5b9250929050565b6000806000806000806060878903121561073c57600080fd5b863567ffffffffffffffff8082111561075457600080fd5b6107608a838b016106d7565b9098509650602089013591508082111561077957600080fd5b6107858a838b016106d7565b9096509450604089013591508082111561079e57600080fd5b506107ab89828a016106d7565b979a9699509497509295939492505050565b80356001600160a01b03811681146107d457600080fd5b919050565b6000602082840312156107eb57600080fd5b6107f4826107bd565b9392505050565b6000815180845260005b8181101561082157602081850181015186830182015201610805565b506000602082860101526020601f19601f83011685010191505092915050565b60006020808301818452808551808352604092508286019150828160051b87010184880160005b838110156108bf57888303603f19018552815180516001600160a01b03168452878101516060898601819052906108a1828701826107fb565b92890151958901959095525094870194925090860190600101610868565b509098975050505050505050565b600080604083850312156108e057600080fd5b6108e9836107bd565b946020939093013593505050565b6001600160a01b038416815260606020820181905260009061091b908301856107fb565b9050826040830152949350505050565b634e487b7160e01b600052603260045260246000fd5b6000808335601e1984360301811261095857600080fd5b83018035915067ffffffffffffffff82111561097357600080fd5b60200191503681900382131561071c57600080fd5b634e487b7160e01b600052604160045260246000fd5b600181811c908216806109b257607f821691505b6020821081036109d257634e487b7160e01b600052602260045260246000fd5b50919050565b601f821115610a2257600081815260208120601f850160051c810160208610156109ff5750805b601f850160051c820191505b81811015610a1e57828155600101610a0b565b5050505b505050565b815167ffffffffffffffff811115610a4157610a41610988565b610a5581610a4f845461099e565b846109d8565b602080601f831160018114610a8a5760008415610a725750858301515b600019600386901b1c1916600185901b178555610a1e565b600085815260208120601f198616915b82811015610ab957888601518255948401946001909101908401610a9a565b5085821015610ad75787850151600019600388901b60f8161c191681555b5050505050600190811b01905550565b600060018201610b0757634e487b7160e01b600052601160045260246000fd5b5060010190565b60006040820160018060a01b0380861684526020604081860152828654808552606094508487019150848160051b8801016000898152848120815b84811015610c0157605f198b850301865287825416845260018083018a89870152848154610b768161099e565b808e8a0152608085831660008114610b955760018114610baf57610bda565b60ff1984168b83015282151560051b8b0182019450610bda565b858a528d8a208a5b84811015610bd25781548d8201850152908801908f01610bb7565b8c0183019550505b50505050600285015460409790970196909652505094860194600390910190600101610b49565b50919b9a505050505050505050505056fea2646970667358221220af7b65fb80f47b49e5e8fe14d0741fbd37f580b1cc0964634a304880010f89aa64736f6c63430008110033";
const isSuperArgs = (xs) => xs.length > 1;
class VoteDelegation__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.VoteDelegation__factory = VoteDelegation__factory;
VoteDelegation__factory.bytecode = _bytecode;
VoteDelegation__factory.abi = _abi;
